<div class="scorecard-legend-container">
  <h3>Keyboard Shortcuts</h3>
  <ul>
    @if (currentMode() === 'scores' || currentMode() === 'stats' || currentMode() === 'verify') {
    <li><strong>Enter:</strong> Move to next input field to the right</li>
    <li><strong>Tab:</strong> Move to next tab/input in sequence</li>
    <li><strong>Shift+Tab:</strong> Move to previous tab/input in sequence</li>
    }
    @if (currentMode() === 'verify') {
    <li>
      <strong>Ctrl+H:</strong> Toggle display of official
      scorecards
    </li>
    }
    @if (currentMode() === 'verify') {
    <li>
      <strong>Ctrl+O:</strong> Mark current scorecard as
      official
    </li>
    }
    @if (currentMode() === 'scores' || currentMode() === 'stats' || currentMode() === 'verify') {
    <li><strong>Ctrl+S:</strong> Open player search modal</li>
    }
    @if (currentMode() === 'scores' || currentMode() === 'stats' || currentMode() === 'verify') {
    <li>
      <strong>Arrow Navigation:</strong>
      <ul>
        @if (currentMode() === 'scores' || currentMode() === 'stats' || currentMode() === 'verify') {
        <li><strong>Right Arrow:</strong> Move to next input to the right</li>
        }
        @if (currentMode() === 'scores' || currentMode() === 'stats' || currentMode() === 'verify') {
        <li><strong>Left Arrow:</strong> Move to next input to the left</li>
        }
        @if (currentMode() === 'scores' || currentMode() === 'stats' || currentMode() === 'verify') {
        <li><strong>Up Arrow:</strong> Move to input directly above</li>
        }
        @if (currentMode() === 'scores' || currentMode() === 'stats' || currentMode() === 'verify') {
        <li><strong>Down Arrow:</strong> Move to input directly below</li>
        }
        @if (currentMode() === 'stats' || currentMode() === 'verify') {
        <li><strong>Ctrl+Right:</strong> Navigate to next player</li>
        }
        @if (currentMode() === 'stats' || currentMode() === 'verify') {
        <li><strong>Ctrl+Left:</strong> Navigate to previous player</li>
        }
        @if (currentMode() === 'scores') {
        <li><strong>Ctrl+Down:</strong> Navigate to next group</li>
        }
        @if (currentMode() === 'scores') {
        <li><strong>Ctrl+Up:</strong> Navigate to previous group</li>
        }
      </ul>
    </li>
    }
  </ul>
</div>